import * as React from 'react';
const StitichezzaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="m82.3 117.7-20.71 20.71M138.41 61.59l-33.75 33.75"
      className="prefix__cls-1"
    />
    <path
      d="M89.89 68.39a5.06 5.06 0 0 0-5.06-5.06h-7.59a5.06 5.06 0 0 0-5.06 5.06v32.87h17.7V68.39ZM72.18 70.92h17.71M78.51 77.24h5.05M89.89 101.26h37.93c0 9.78-7.93 17.7-17.7 17.7h-7.59"
      className="prefix__cls-2"
    />
    <path
      d="m111.38 118.97 3.79 17.7H86.09l3.79-17.7c-9.78 0-17.7-7.92-17.7-17.7M127.82 101.26a5.06 5.06 0 0 0-5.06-5.06H100a5.06 5.06 0 0 0-5.06 5.06"
      className="prefix__cls-2"
    />
  </svg>
);
export default StitichezzaIcon;
